import { render } from "./SecurityView.vue?vue&type=template&id=2e5366d4"
import script from "./SecurityView.vue?vue&type=script&lang=js"
export * from "./SecurityView.vue?vue&type=script&lang=js"
script.render = render

export default script